<template>
  <div class="circle-card text-center h-100">
    <img
      v-if="circle.upload && circle.upload.path"
      class="circle-card__logo"
      :src="circle.upload.path"
      alt="Circle Logo"
    />
    <img v-else class="circle-card__logo" width="40" src="../../../assets/avatar.png" alt />
    <router-link :to="'/circle/' + circle._id">
      <h3 class="circle-card__name mt-3 mb-1">{{circle.title}}</h3>
    </router-link>
    <span
      class="circle-card__meta"
    >{{circle.member_count}} {{circle.member_count > 1 || circle.member_count === 0 ? 'members' : 'member'}}</span>
    <!-- Button states -->
    <button @click="joinCircle" v-if="!circle.joined" class="btn btn-primary btn-sm mt-3">Join</button>
    <button v-else class="btn btn-primary btn-sm mt-3" disabled>Joined</button>
  </div>
</template>

<script>

export default {
	name: 'CircleCard',
	props: ["circle", "user"],
	methods: {
		joinCircle() {
			this.$root.$emit('JoinRecommendedCircle', { circle: this.$props.circle, user: this.$props.user });
		}
	}
}
</script>

<style lang="scss" scoped>
	.circle-card {
		background: #fff;
		border: 1px solid #efefef;
		border-radius: 6px;
		padding: 20px;
		margin-bottom: 15px;
		&__name {
			font-size: 14px;
			line-height: 20px;
			margin-bottom: -5px;
		}
		&__meta {
			color: #919EAB;
			font-size: 13px;
		}
		&__logo {
			border-radius: 100%;
			height: 70px;
			width: 70px;
		}
		.btn {
			margin: 0 auto;
		}
	}
</style>